import { nanoid } from 'nanoid';
export class AutoId {
  /** generate 20 random characters. */
  static newId(): string {
    return nanoid(20);
  }
}
